import { createSelector } from 'reselect';

const domain = () => (state) => state.get('confirmDialog');

const selectorConfirmDialogDisplay = () =>
  createSelector(domain(), (substate) => substate.get('display'));

export { selectorConfirmDialogDisplay };
